import script from "./NewsDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./NewsDetailPage.vue?vue&type=style&index=0&id=57b21cde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57b21cde"]])

export default __exports__